const styles = theme => ({
  toolbarFlexStyle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
})

export default styles
